import React from 'react';
import styled from 'styled-components';
import { media, theme } from '@marketing-site/styles';
import {
  Box,
  Button,
  Divider,
  Grid,
  Link,
  Menu,
  MenuItem,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { Job } from '@marketing-site/api/careers/apiSlice';

export const Listing = ({ job }: { job: Job }) => {
  return (
    <Grid container spacing={200}>
      <Grid item sm={12} md={4}>
        <Typography fontSize={'16px'} fontWeight={600}>
          {job.title}
        </Typography>
      </Grid>
      <Grid item sm={4} md={2}>
        <Typography fontSize={'16px'}>{job.department}</Typography>
      </Grid>
      <Grid item sm={12} md={3}>
        <Typography fontSize={'16px'}>{job.location}</Typography>
      </Grid>
      <Grid item sm={4} md={2}>
        <Typography fontSize={'16px'}>{job.employmentType}</Typography>
      </Grid>
      <Grid item sm={12} md={1}>
        <Typography fontSize={'16px'}>
          <Link
            href={job.jobUrl}
            sx={{
              textDecoration: 'none',
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ borderStyle: 'dashed' }} />
      </Grid>
    </Grid>
  );
};
